import { gql } from '@apollo/client';
import { BUSINESS_ALERT_FIELDS_FRAGMENT } from './businessAlertFieldsFragment.gql';
export const GET_BUSINESS_ALERTS_FOR_ACCOUNT = gql`
  ${BUSINESS_ALERT_FIELDS_FRAGMENT}
  query getBusinessAlertFind($filter: BusinessAlertFilter) {
    businessAlertsFind(filter: $filter) {
      nodes {
        ...BusinessAlertFields
      }
    }
  }
`;

export const GET_BUSINESS_ALERTS_READ_DATA = gql`
  query getBusinessAlertReadsFind(
    $filter: BusinessAlertReadFilter
    $sorting: [BusinessAlertReadSort!]
    $paging: CursorPaging
  ) {
    businessAlertReadsFind(filter: $filter, sorting: $sorting, paging: $paging) {
      nodes {
        objectId: id
        createdAt
        updatedAt
        lastReadAt
        simplrAccountId
        simplrAccountPtr {
          objectId: id
        }
        businessAlertId
        businessAlertPtr {
          objectId: id
        }
        simplrExpertId
        simplrExpertPtr {
          objectId: id
        }
      }
    }
  }
`;
